import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, Button, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { updateMyTaskReport } from "../../services/employeeApi.js";
import { toast } from "react-toastify";
import { validateForm } from "../../middleware/validatemyTaskReportForm.js";
const UpdateTaskReportForm = ({ reportUpdateData, onSubmitButton }) => {
  const { t } = useTranslation();
  let history = useHistory();
  const [formerror, setFormError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const queryClient = useQueryClient();
  const updateReportMutation = useMutation(async (newData) => {
    await updateMyTaskReport(newData);
    queryClient.invalidateQueries("get-my-tasks-status");
  });
  const [formData, setFormData] = useState({
    current_remark: reportUpdateData.current_remark,
    amount_birr: reportUpdateData.amount_birr,
    quantity: reportUpdateData.quantity,
    date: new Date(reportUpdateData.date).toISOString().split("T")[0],
    id: reportUpdateData.id,
    status: "pending",
  });

  const handleUpdateReport = async (reportUpdateData) => {
    try {
      setIsSubmitting(true);
      await updateReportMutation.mutateAsync(reportUpdateData);
      toast.success("Updated successful", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      handleCloseModal();
      history.push(`/my-tasks`);
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    handleUpdateReport(formData);
  };
  const handleCancelReport = (e) => {
    e.preventDefault();
    const updatedData = { ...formData, status: "Canceled" };
    handleUpdateReport(updatedData);
    handleCloseModal();
  };

  const handleCloseModal = () => {
    onSubmitButton();
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <div className="col-md-12 mb-3">
          <Form.Label className="font-weight-bold text-muted">
            {t("task_name")} {reportUpdateData.task_title}
          </Form.Label>
        </div>

        <div className="col-md-12 mb-3">
          <Form.Label htmlFor="Text4" className="font-weight-bold text-muted ">
            {t("date")}
          </Form.Label>
          <Form.Control
            type="date"
            required
            placeholder="Enter date"
            value={formData.date}
            onChange={(e) => handleInputChange(e, "date")}
          />
        </div>
        <div className="col-md-12 mb-3">
          <Form.Label htmlFor="Text1" className="font-weight-bold text-muted ">
            {t("quantity")}
          </Form.Label>
          <Form.Control
            type="number"
            min="0"
            required
            placeholder="Enter Quantity"
            value={formData.quantity}
            rows={3}
            onChange={(e) => handleInputChange(e, "quantity")}
          />
        </div>

        <div className="col-md-12 mb-3">
          <Form.Label htmlFor="Text1" className="font-weight-bold text-muted ">
            {t("amount_birr")}
          </Form.Label>
          <Form.Control
            type="number"
            min="0"
            placeholder="Enter amount in ETB"
            value={formData.amount_birr}
            required
            onChange={(e) => handleInputChange(e, "amount_birr")}
          />
        </div>
        <div className="col-md-12 mb-3">
          <Form.Label htmlFor="Text1" className="font-weight-bold text-muted ">
            {t("remark")}
          </Form.Label>
          <Form.Control
            as="textarea"
            id="horizontalTextarea"
            rows="3"
            value={formData.current_remark}
            required
            onChange={(e) => handleInputChange(e, "current_remark")}
            placeholder="Provide details for managerial consideration"
          ></Form.Control>
          {formerror ? (
            <p className="text-danger">
              Looks like something’s missing! Please make sure to complete all
              required fields before submitting your report.
            </p>
          ) : (
            ""
          )}
        </div>

        <div className="d-flex mt-1">
          <div className="mb-1">
            <Button
              className="bt btn-danger"
              onClick={(e) => handleCancelReport(e)}
            >
              {t("remove_submited_report")}
            </Button>
          </div>
          <div className="col-md-6 mb-1">
            <Button
              className="bt btn-info"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Sending...</span>
                </span>
              ) : (
                t("update_and_submit")
              )}
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default UpdateTaskReportForm;
